
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuEkichikaHarajukuStationNearImage } from "@src/constants/images";
import { meta as micasadecoPageMeta } from "./micasadeco.mdx";
export const meta = {
  path: "/media/harajuku/lunch_adult",
  title: "【雰囲気抜群】原宿で大人が楽しめるランチ５選！",
  description: "原宿でいつもとは違う落ち着いた大人な雰囲気と味が楽しめるお店でランチを食べたいという方も多いのではないでしょうか。そんな方でも楽しめる大人なお店をジャンル別に分けて５つご紹介させていただきます。大人が楽しめることをコンセプトにしたお店や、女子会で人気なお店、ミシュランに選ばれる店など、ランチを楽しめる情報が詰まっているので、是非ご覧ください。",
  topImg: harajukuEkichikaHarajukuStationNearImage,
  author: murakamiMasanori,
  tags: ["原宿", "人気店", "まとめ記事", "大人向け", "カフェ", "落ち着いた雰囲気"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿でいつもとは違う落ち着いた大人な雰囲気と味が楽しめるお店でランチを食べたいという方も多いのではないでしょうか。`}</p>
    <p>{`そんな方でも楽しめる大人なお店をジャンル別に分けて５つご紹介させていただきます。`}</p>
    <p>{`大人が楽しめることをコンセプトにしたお店、ミシュランに選ばれる店、大人ランチお店、原宿で屈指のイタリアンの名店、料亭のような雰囲気店など、どこのランチも大人だからこそ楽しめるものにになっているので、是非ご覧ください。`}</p>
    <h2>{`【カフェ】ミカサデコ＆カフェ`}</h2>
    <InstaImage postId="CBh-MN1JPGO" mdxType="InstaImage" />
    <p>{`大人が楽しめるカフェがコンセプトとして、2020 年に神宮前から原宿の裏原の方面に移動したばかりのお店。青を基調としたスタイリッシュな外観に、オレンジ色の照明で温かみのある店内が、コンセプトにぴったりな大人なお店です。`}</p>
    <InstaImage postId="CBE9ZU0gjRa" mdxType="InstaImage" />
    <p>{`ウーバーイーツやテイクアウトなどもできるようになっていて、ランチを店内で食べるだけでなく、その日の気分に合わせてランチの食べ方を選べることも大人から人気になっている秘密。`}</p>
    <h3>{`大人な空間`}</h3>
    <InstaImage postId="B02Sk3DA6bw" mdxType="InstaImage" />
    <p>{`青を基調とした洗練された空間は、どこか落ち着く安心感のあるような雰囲気になっています。
店内でゆっくり過ごしたい方には、おすすめの空間。`}</p>
    <h3>{`豊富なランチメニュー`}</h3>
    <InstaImage postId="CBaCI6ynMax" mdxType="InstaImage" />
    <InstaImage postId="BkXv6CcA2RT" mdxType="InstaImage" />
    <p>{`インスタグラムで検索するとパンケーキの写真をたくさん見かけ、ミカサデコ＆カフェを紹介する記事でもパンケーキの紹介をされていることが多いですが、しっかりお食事を楽しんでもらえることもコンセプトの一つとなっています。`}</p>
    <p>{`なので、カレー、ビーフストロガノフ、サラダラップ、パスタ、ランチプレートなど、様々なメニューが取り揃えられており、その時の気分を満たしてくれるお店です。`}</p>
    <LinkWithThumbnail meta={micasadecoPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="breespi23akg00eoptr0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【蕎麦】玉笑`}</h2>
    <InstaImage postId="CAWXkDCg9Xe" mdxType="InstaImage" />
    <p>{`日本一とも言われる蕎麦の名店で、ミシュランにも数年連続の選出をされているほどの実力店。落ち着いた店内で食べる気品のある蕎麦は大人が食べたくなる一品。明治神宮前からのアクセスが抜群で、行列ができることもよくあり、売り切れ次第閉店のため、早めの時間帯に行っておきたいお店。`}</p>
    <h3>{`名物「納豆蕎麦」`}</h3>
    <InstaImage postId="Bk_dddRFJPh" mdxType="InstaImage" />
    <p>{`インスタグラムでもたくさん写真が UP されているランチメニューで、玉笑の名物メニューで、大粒の納豆に、卵、薬味、海苔などがトッピングされており、混ぜて食べるそばは、洗練された味わいで大人が食べたくなる一品。`}</p>
    <h3>{`せいろ蕎麦`}</h3>
    <InstaImage postId="B9trQt7gAQg" mdxType="InstaImage" />
    <p>{`卵と薬味、そしてつゆを入れて食べるせいろ蕎麦が玉笑流。
自家製の麺は見た目からコシを感じさせる太麺で、歯応えのある食感が楽しめる他店にはない蕎麦ではないでしょうか。
普段のランチとは違った、贅沢な時間を過ごしてみるのはいかがでしょうか。`}</p>
    <ShopInfoBox shopId="brh1uvq23akg00da7npg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【ピザ】ピッツェリア カンテラ`}</h2>
    <InstaImage postId="Bvg_XpHA5cc" mdxType="InstaImage" />
    <p>{`原宿ランチの中で、女性会やランチ会をはじめとして、ランチ・ディナー問わず人気なお店がピッツェリア カンテラ。
開放的なテラス席やスタイリッシュで温かみのあるおしゃれな店内は原宿の喧騒からは想像できないくらいで、一度はランチを食べてみたいという方も多くご来店されています。`}</p>
    <p>{`また食べログの評価も 3.6 を超え、3 年連続百名店に選出される実績もあり、一度は食べておきたいピザの名店。`}</p>
    <h3>{`ピザセット`}</h3>
    <InstaImage postId="Bz7Fh3PALnF" mdxType="InstaImage" />
    <p>{`窯で焼くピザの生地の食感はパリッとした食感に加えモチッとした生地は、全粒粉を使用しているため、生地の食感だけでなく体にも優しい大人な一品。その生地をベースとして、新鮮な食材をふんだんに使用したピザランチを楽しむことができます。`}</p>
    <h3>{`パスタセット`}</h3>
    <InstaImage postId="Bz58cwngHMh" mdxType="InstaImage" />
    <p>{`各地の新鮮な食材を使用したパスタランチは、ラグーソースやポモドーロなどをベースとしたメニューが多く、平日だとが 1,100 円で食べることができるそうです！仕事休憩の時に同僚と、また休日は友人と一緒にお越しいただき、ランチ・ディナー問わず大人な空間で食事の時間を過ごしてみるのはいかがでしょうか。`}</p>
    <ShopInfoBox shopId="brjat6223akg00cd2nu0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【イタリアン】エミリア`}</h2>
    <InstaImage postId="CA-fw0nD8JW" mdxType="InstaImage" />
    <p>{`レトロな雰囲気をした外観が特徴的なお店で、カウンター席も完備しており、大人の方には嬉しい落ち着いた店内。`}</p>
    <p>{`原宿界隈では屈指のイタリアンとして有名で、食べログの評価も 3.7 を超えるなど、知る人ぞ知る人気のお店です。
ディナーでご利用される方も多いと思いますが、名物の手打ちパスタがランチだとお得に食べることができるので、落ち着いた雰囲気で名物メニューをランチで食べるのがおすすめです！`}</p>
    <h3>{`平日限定パスタランチがお得`}</h3>
    <InstaImage postId="BtQoNUGgzGb" mdxType="InstaImage" />
    <p>{`平日、休日問わず、ゆっくり落ち着いた大人な体験をしたい方も多いのではないでしょうか。
お好きなパスタ、自家製のパン、食後の飲み物がついて 1,100 円のパスタランチ。値段はもちろんのこと、美味しさを引き立ててくれる大人で落ち着いた空間も加味すると、有名店の味がお手頃に楽しめるのがエミリアの魅力ではないでしょうか。`}</p>
    <ShopInfoBox shopId="brh20ka23akg00da7nv0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【焼き鳥】鳥政`}</h2>
    <InstaImage postId="B-Heo7wpNBa" mdxType="InstaImage" />
    <p>{`原宿から表参道方面に進んだ先に、日本料亭のような外観をしたお店が焼き鳥の名店「鳥政」です。
カウンター席が多く、お一人様も入りやすい店内は、まさに大人の落ち着いた雰囲気でランチを食べたい方にはぴったりのお店。
食べログの評価は 3.7 を超え、百名店にも選出される人気店。その人気のせいか、平日・休日問わず、ランチタイムには行列ができることもしばしば。`}</p>
    <h3>{`焼き鳥丼のランチセット`}</h3>
    <InstaImage postId="BpNY-ssA-T9" mdxType="InstaImage" />
    <p>{`5 種の焼き鳥をふんだんに使用し、それぞれの鶏肉の味を最大限に引き出した、味わいのある大人なメニュー。
芳醇な鶏の香ばしい香りだけでなく、自家製のタレがかかった鶏とご飯を一緒に食べると、食欲が湧いてくるような一品になって言います。
特にレバーは奥行きのある味わいで、大人の方にはぴったりの一品。`}</p>
    <h3>{`串焼きのランチセット`}</h3>
    <InstaImage postId="BBzUvQLi5Vo" mdxType="InstaImage" />
    <p>{`焼き鳥丼のランチセット全く同じ鶏肉ですが、ご飯と串が分けられているランチメニューになります。
鶏肉１つ１つの味を楽しんで食べたい方には、こちらのランチメニューがおすすめです。`}</p>
    <ShopInfoBox shopId="brgc60a23akg00bq2p00" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに　`}</h3>
    <p>{`原宿で大人なランチが食べられるお店をご紹介してきましたが、いかがでしたでしょうか。`}</p>
    <p>{`大人でも楽しめる空間づくりにこだわっているお店から、大人だからこそ楽しめる奥行きのある食材を使用したメニューを楽しめるお店まで、ジャンル別に５つご紹介してきました。`}</p>
    <p>{`普段とは違った、原宿だけど落ち着いた大人な空間で、色の味を最大限に引き出しているような大人なランチを楽しんでいただければと思います。`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;